<template>
  <div class="card shadow-sm position-relative h-100">
    <span
      v-if="assigned"
      class="badge bg-success shadow-sm assigned animate__animated animate__bounceIn animate__faster">
      <i class="fa fa-check-circle"/>
      Assigned
    </span>
    <img
      :src="imageUrl(item.imageFilename)"
      style="height: 14em; object-fit: contain;"
      class="card-img-top"
      @error="imgError">
    <div class="card-body">
      <div style="height: 3em; overflow: hidden;">
        <strong class="card-title">{{ item.name }}</strong>
      </div>
      <p class="card-text">
        <table
          class="table table-sm table-bordered"
          style="font-size: 12px;">
          <tbody>
            <tr>
              <td>Type</td>
              <td class="text-muted">{{ item.merchandisingType }}</td>
            </tr>
            <tr>
              <td>PriceLine</td>
              <td class="text-muted">{{ item.priceLine }}</td>
            </tr>
            <!-- <tr>
              <td>Product ID</td>
              <td class="text-muted">{{ item.eclipseId }}</td>
            </tr> -->
            <tr>
              <td>Collection</td>
              <td class="text-muted">{{ item.collection}}</td>
            </tr>
          </tbody>
        </table>
      </p>
    </div>
    <div
      class="card-footer"
      style="height: 3em;">
      <button
        v-if="!assigned"
        class="btn btn-sm w-100"
        :class="assigned ? 'btn-success animate__animated animate__bounceIn animate__faster' : 'btn-primary'"
        :disabled="assigned || loading"
        @click="assign">
        <span>
          <i
            v-if="!assigned && loading"
            class="fa fa-spinner fa-spin"/>
          <i  
            v-if="!assigned && !loading"
            class="fa fa-plus"/>
          Assign
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
  import comingsoon from '../../../../../../../../shared/comingSoon';
  import { imageUrl } from '../../../js/displayTracking';
  import { computed, ref } from 'vue';
  import { useStore } from 'vuex';

  // Initialize
  const props = defineProps(['item', 'customer', 'merchIds'])
  const store = useStore()

  // Data
  const loading = ref(false)

  // Methods
  const imgError = (e)=>{
    return comingsoon(e)
  }

  const assign = ()=>{
    loading.value = true
    const data = {
      item: props.item,
      customer: props.customer,
      qty: 1
    }
    store.dispatch('displayTrackingTransaction', data)
  }

  // Computed
  const assigned = computed(()=>{
    return props.merchIds.includes(props.item.id)
  })

</script>

<style scoped>
  .assigned{
    width: 8em;
    right: -3px;
    top: -3px;
    position: absolute;
    font-size: 14px;
  }
</style>
